export function FormError({ message }) {
  if (!message) return null;

  return <p className="tdw-form-error">{message}</p>;
}
